<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card.coupons
        v-card-title.px-5
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-arrow-left
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('coupons') }}
        v-card-text.background-header.white
          v-container.pb-0.white.sticky-header-container(style="max-width: 600px")
            div.mx-2
              v-text-field.my-2(v-model="searchText" hide-details dense outlined background-color="basic200" height="40" :placeholder="$t('search_coupons')")
                template(v-slot:append)
                  eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")

              div(v-if="member.role === 'Admin'")
                v-btn.px-0(color='transparent' text :ripple="false" @click="clickAddProduct")
                  eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="20")
                  .info500--text.s1.text-capitalize| {{ $t('create_new_coupon') }}
            
          v-container(style="max-width:600px")
            v-layout.my-6(v-if="isFetching")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contain-layout(v-else)
              v-layout.my-6(v-if="coupons.length == 0")
                v-row.fill-height.ma-0(align='center' justify='center')
                  div.mx-auto
                    v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                    p.caption {{ $t('coupons_not_found') }}
              .items-layout(v-else)
                .list-item.my-2
                  template(v-for='coupon in coupons')
                    coupon-item(:parentCoupon.sync="coupon" :key="coupon.id" @deleted="handleDeleteItem" @edited="handleEditItem")
                    
            div.mt-4
              y-pagination.mt-4.mb-6(v-model="page" :pageSize="fetchCount" :count="totalCount")

    .modals
      add-coupon(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :company="company" @added="handleAddItem")

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import queryString from 'query-string'
import AddCoupon from '@/components/offers/dialogs/coupons/AddCoupon.vue'
import CouponItem from '@/components/offers/CouponItem.vue'

export default {
  name: 'Coupons',
  components: { AddCoupon, CouponItem },
  props: ['open'],
  data: () => ({
    showHeader: true,
    lastScrollPosition: 0,
    isFetching: false,
    showAddProductDialog: false,
    isTyping: false,
    fetchCount: 10,
    totalCount: 0,
    page: 1,
    totalPage: 1,
    coupons: [],
    searchText: '',
    searchCountDown: null
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany',
    }),
    showModal: {
      get() {
        return this.open
      },
      set(val) {
        return this.$emit('update:open', val)
      }
    }
  },
  mounted() {
    if (!this.$route.query.page) {
      this.fetchCoupons(1)
    } else {
      this.fetchCoupons(this.$route.query.page)
    }
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  watch: {
    page(val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchCoupons(val)
      }
    },
    searchText() {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  methods: {
    fetchCoupons(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/promo/coupons/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id`
      if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      this.$axios
        .get(url)
        .then(response => {
          this.isFetching = false
          this.coupons = response.data.results
          this.totalCount = response.data.count
          if (this.totalCount % this.fetchCount == 0) {
            this.totalPage = this.totalCount / this.fetchCount
          } else {
            this.totalPage = this.totalCount / this.fetchCount + 1
          }
          this.totalPage = parseInt(this.totalPage)
        })
        .catch(() => {})
    },
    clickAddProduct() {
      this.showAddProductDialog = true
    },
    searchItem() {
      let searchUrl = `/promo/coupons/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios
        .get(searchUrl)
        .then(response => {
          this.isFetching = false
          this.coupons = response.data.results
          this.totalCount = response.data.count
          if (this.totalCount % this.fetchCount == 0) {
            this.totalPage = this.totalCount / this.fetchCount
          } else {
            this.totalPage = this.totalCount / this.fetchCount + 1
          }
          this.totalPage = parseInt(this.totalPage)
        })
        .catch(() => {})
    },
    handleDeleteItem(item) {
      this.coupons = this.coupons.filter(x => x !== item)
    },
    handleAddItem(item) {
      this.coupons.splice(0, 0, item)
    },
    handleEditItem(item) {
      let editIndex = 0
      this.coupons.forEach((coupon, index) => {
        if (coupon.id === item.id) {
          editIndex = index
        }
      })
      this.coupons = this.coupons.filter(x => x.id !== item.id)
      this.coupons.splice(editIndex, 0, item)
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.showHeader = currentScrollPosition < this.lastScrollPosition
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition
    }
  }
}
</script>
<style scoped>
.sticky-header-container {
  position: relative;
  background-color: var(--v-basic100);
  height: 80px;
}
.sticky-header {
  position: fixed;
  transition: 0.3s all ease-out;
  transform: translate3d(0, 0, 0) !important;
  z-index: 3;
  width: 100%;
  max-width: 600px;
  background-color: var(--v-basic100);
}
.sticky-header.hidden-header {
  transform: translate3d(0, -100%, 0) !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "search_coupons": "Search coupons",
    "create_new_coupon": "Create New Coupon",
    "coupons_not_found": "Coupons not found or empty"
  },
  "id": {
    "search_coupons": "Cari kupon",
    "create_new_coupon": "Buat Kupon Baru",
    "coupons_not_found": "Coupons not found or empty"
  }
}
</i18n>
